import { useState, useEffect, useCallback } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollTo = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const links = [
    { id: 'sobre', label: 'Sobre' },
    { id: 'areas', label: 'Atuação' },
    { id: 'clinica', label: 'Clínica' },
    { id: 'depoimentos', label: 'Depoimentos' },
    { id: 'conteudos', label: 'Conteúdos' },
    { id: 'faq', label: 'FAQ' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-[1000] transition-all duration-700 ${
        scrolled
          ? 'bg-white/70 backdrop-blur-2xl shadow-[0_1px_30px_rgba(0,0,0,0.02)] border-b border-white/50'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-8 md:px-12 flex items-center justify-between h-20 md:h-24">
        {/* Logo */}
        <button
          onClick={() => scrollTo('hero')}
          className={`flex flex-col transition-all duration-700 hover:opacity-80 ${
            scrolled ? '' : 'mix-blend-difference'
          }`}
          style={{
            transform: scrolled ? 'scale(0.88)' : 'scale(1)',
          }}
        >
          <span className={`font-heading text-lg md:text-xl font-medium tracking-[0.2em] whitespace-nowrap transition-colors duration-700 ${
            scrolled ? 'text-graphite' : 'text-white'
          }`}>
            DRA. NATHÁLIA POSSO
          </span>
          <span className={`font-body text-[9px] tracking-[0.35em] whitespace-nowrap transition-colors duration-700 ${
            scrolled ? 'text-secondary-500' : 'text-white/55'
          }`}>
            GINECOLOGIA
          </span>
        </button>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-10">
          {links.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`font-body text-xs tracking-[0.15em] uppercase transition-all duration-300 relative after:absolute after:bottom-[-5px] after:left-0 after:w-0 after:h-[1px] after:bg-gold-matte after:transition-all after:duration-400 hover:after:w-full whitespace-nowrap ${
                scrolled
                  ? 'text-graphite/55 hover:text-graphite'
                  : 'text-white/65 hover:text-white'
              }`}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('hero')}
            className={`btn-shimmer font-body text-xs font-semibold px-6 py-3 tracking-[0.1em] uppercase transition-all duration-500 whitespace-nowrap hover:scale-[1.03] ${
              scrolled
                ? 'text-white bg-graphite hover:bg-graphite/85'
                : 'text-graphite bg-white hover:bg-white/90'
            }`}
          >
            Agendar Consulta
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden flex flex-col gap-1.5 p-2 transition-all duration-300 hover:opacity-70"
          aria-label="Menu"
        >
          <span className={`block w-5 h-[1px] transition-all duration-300 ${mobileOpen ? 'rotate-45 translate-y-[3px] bg-graphite' : scrolled ? 'bg-graphite' : 'bg-white'}`} />
          <span className={`block w-5 h-[1px] transition-all duration-300 ${mobileOpen ? 'opacity-0' : scrolled ? 'bg-graphite' : 'bg-white'}`} />
          <span className={`block w-5 h-[1px] transition-all duration-300 ${mobileOpen ? '-rotate-45 -translate-y-[3px] bg-graphite' : scrolled ? 'bg-graphite' : 'bg-white'}`} />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ${
          mobileOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-white/95 backdrop-blur-2xl px-8 pb-8 flex flex-col gap-5 items-center">
          {links.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="font-body text-sm text-graphite/65 hover:text-graphite tracking-[0.15em] uppercase transition-colors duration-300 whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('hero')}
            className="font-body text-xs font-semibold text-white bg-graphite hover:bg-graphite/85 hover:scale-[1.03] px-8 py-3 tracking-[0.1em] uppercase mt-2 transition-all duration-500 whitespace-nowrap"
          >
            Agendar Consulta
          </button>
        </div>
      </div>
    </nav>
  );
}